import { useAuth } from "@/contexts/auth/useAuth";

import type { CSSProperties } from "react";

/** Locales which should be presented in right-to-left. */
const RTL_LOCALES = ["ar", "ckb", "fa", "he"];

interface UseLocaleResult {
  locale: string;
  direction: CSSProperties["direction"];
}

/** Get valid locale from settings. */
const useLocale = (fallback = "en"): UseLocaleResult => {
  const { currentAccount } = useAuth();
  const locale = currentAccount?.settings?.locale || fallback;

  const direction: CSSProperties["direction"] = RTL_LOCALES.includes(locale)
    ? "rtl"
    : "ltr";

  return {
    locale,
    direction,
  };
};

export { useLocale };
